export const CategoriesData = [
  {
    title: "All Products",
    path: "allproducts"
  },
  {
    title: "Men",
    path: "mens"
  },
  {
    title: "Jewelery",
    path: "jewelery"
  },
  {
    title: "Electronics",
    path: "electronics"
  },
  {
    title: "Women",
    path: "womens",
  }
];